import { FormSchema } from '@/forms/types/schema';

export type SendAnnouncementFieldValues = {
  notificationText: string;
};

const associateDeviceFormSchema: FormSchema<SendAnnouncementFieldValues> = {
  notificationText: {
    type: 'text',
    label: 'Announcement text',
    value: '',
    validation: { required: true, maxLength: 1024 },
  },
};

export const buildSendAnnouncementFormSchema =
  (): FormSchema<SendAnnouncementFieldValues> => {
    const schema = associateDeviceFormSchema;
    return schema;
  };
